(function () {
  'use strict';

  var PANEL_OPENED = 'panel-opened';
  var PANEL_RIGHT_OPENED = 'panel-right-opened';

  function getRoot() {
    return document.querySelector('.main-side-nav');
  }

  function getOverlay() {
    var root = getRoot();
    if (root) {
      var overlayInNav = root.querySelector('.panel-overlay');
      if (overlayInNav) return overlayInNav;
    }
    return document.querySelector('.panel-overlay');
  }

  function setMenuToggleState(isOpen) {
    document.querySelectorAll('.side-nav-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function openPanel() {
    var panel = document.getElementById('side-nav-panel');
    var root = getRoot();
    if (!panel || !root) return;

    document.documentElement.classList.add(PANEL_OPENED);
    setMenuToggleState(true);
    var overlay = getOverlay();
    if (overlay) overlay.classList.add('active');
    if (panel.classList.contains('panel-right')) {
      document.documentElement.classList.add(PANEL_RIGHT_OPENED);
    }
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    var html = document.documentElement;
    html.style.transition = 'margin .3s';
    html.classList.remove(PANEL_OPENED, PANEL_RIGHT_OPENED);
    setMenuToggleState(false);
    window.setTimeout(function () {
      html.style.transition = '';
    }, 260);

    var overlay = getOverlay();
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function togglePanel() {
    if (document.documentElement.classList.contains(PANEL_OPENED)) {
      closePanel();
    } else {
      openPanel();
    }
  }

  var SLIDE_DURATION = 300;

  function slideDown(subMenu) {
    subMenu.style.display = 'block';
    subMenu.style.overflow = 'hidden';
    subMenu.style.maxHeight = '0';
    subMenu.style.transition = 'max-height ' + SLIDE_DURATION + 'ms ease';
    subMenu.offsetHeight;
    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';

    subMenu.addEventListener(
      'transitionend',
      function onEnd(e) {
        if (e.propertyName !== 'max-height') return;
        subMenu.style.maxHeight = '';
        subMenu.style.overflow = '';
        subMenu.style.transition = '';
        subMenu.removeEventListener('transitionend', onEnd);
      }
    );
  }

  function slideUp(subMenu) {
    subMenu.style.overflow = 'hidden';
    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
    subMenu.style.transition = 'max-height ' + SLIDE_DURATION + 'ms ease';
    subMenu.offsetHeight;
    subMenu.style.maxHeight = '0';

    subMenu.addEventListener(
      'transitionend',
      function onEnd(e) {
        if (e.propertyName !== 'max-height') return;
        subMenu.style.display = 'none';
        subMenu.style.maxHeight = '';
        subMenu.style.overflow = '';
        subMenu.style.transition = '';
        subMenu.removeEventListener('transitionend', onEnd);
      }
    );
  }

  function openSubMenu(li, subMenu, animate) {
    li.classList.add('open');
    if (animate) {
      slideDown(subMenu);
    } else {
      subMenu.style.display = 'block';
    }
  }

  function closeSubMenu(li, subMenu, animate) {
    li.classList.remove('open');
    if (animate) {
      slideUp(subMenu);
    } else {
      subMenu.style.display = 'none';
    }
  }

  function initAccordionMenus(root) {
    root.querySelectorAll('.accordion-menu:not(.manual)').forEach(function (menu) {
      menu.querySelectorAll('.menu-item-has-children').forEach(function (item) {
        var subMenu = item.querySelector(':scope > .sub-menu');
        if (!subMenu) return;
        subMenu.style.display = 'none';
        item.classList.remove('open');
        var visibleChildren = subMenu.querySelectorAll(':scope > li:not(.hidden-item)');
        if (visibleChildren.length === 0) {
          item.classList.add('hidden-item');
        }
      });

      menu.addEventListener('click', function (e) {
        var arrow = e.target.closest('.arrow');
        if (!arrow || !menu.contains(arrow)) return;

        e.preventDefault();
        e.stopPropagation();

        var li = arrow.closest('li');
        if (!li) return;

        var subMenu = arrow.nextElementSibling;
        if (!subMenu || !subMenu.classList.contains('sub-menu')) return;

        if (li.classList.contains('open')) {
          closeSubMenu(li, subMenu, true);
        } else {
          openSubMenu(li, subMenu, true);
        }
      });
    });
  }

  function initMobileTabs(root) {
    root.querySelectorAll('.mobile-tabs').forEach(function (tabs) {
      tabs.querySelectorAll('.mobile-tab-items .nav-item').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();

          var id = tab.getAttribute('pane-id');
          if (!id) return;

          tabs.querySelectorAll('.active').forEach(function (el) {
            el.classList.remove('active');
          });
          tab.classList.add('active');

          tabs.querySelectorAll('.mobile-tab-content .tab-pane').forEach(function (pane) {
            pane.classList.toggle('active', pane.getAttribute('tab-id') === id);
          });
        });
      });
    });
  }

  function init() {
    var root = getRoot();
    if (!root) return;

    initAccordionMenus(root);
    initMobileTabs(root);

    document.body.addEventListener('click', function (e) {
      if (
        !e.target.closest('.mobile-toggle, .side-nav-toggle, [data-side-nav-toggle]') ||
        !document.getElementById('side-nav-panel')
      ) {
        return;
      }
      e.preventDefault();
      togglePanel();
    });

    var overlay = getOverlay();
    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }

    var closeBtn = root.querySelector('.side-nav-panel-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closePanel();
      });
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth > 991 && document.documentElement.classList.contains(PANEL_OPENED)) {
        closePanel();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains(PANEL_OPENED)) {
        closePanel();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
